module.exports = __webpack_public_path__ + "static/media/threeUp-lost-income.2b45885b.png";